require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-the-future-has-arrived-at-yarrabend.json") })
        }
      }, "path---news-the-future-has-arrived-at-yarrabend");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-the-future-has-arrived-at-yarrabend!./.cache/json/news-the-future-has-arrived-at-yarrabend.json
// module id = 850
// module chunks = 231608221292675